import mixpanel from 'mixpanel-browser'

mixpanel.init('3f3ed7d6d906dc61b21c95126edb5f63')

export default mixpanel
